import { useState } from "react";
import AccountPage from "../../assets/clickthroughAsset/AccountPage.png";
import TutorPage from "../../assets/clickthroughAsset/FindATutorPage.png";
import BookingPage from "../../assets/clickthroughAsset/Booking1.png";
import BookingRequestPage from "../../assets/clickthroughAsset/Booking6.png";

const maxPages = 4;

export function UserGuideModal({ handleCloseTOSModal, page = 0 } : { handleCloseTOSModal: () => void, page?: number }) {

    const [instructionPage, setInstructionPage] = useState(page);

    const handleNext = () => {
        if (instructionPage < maxPages - 1) {
            setInstructionPage(instructionPage + 1);
        }
    }

    const handlePrev = () => {
        if (instructionPage > 0) {
            setInstructionPage(instructionPage - 1);
        }
    }
    return (
        <div className="relative z-10 w-[80%] mx-[10%] py-20"
            role="dialog"
            aria-modal="true">
            <div className="fixed inset-0 bg-gray-300 bg-opacity-75 transition-all backdrop-blur-sm"></div>
            <div className="flex justify-center px-2 py-12 text-center ">
                <div className="fixed rounded-2xl bg-white text-black text-left shadow-xl transition-all p-4">
                    <div className="flex justify-end">
                        <button onClick={handleCloseTOSModal}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    {
                        instructionPage === 0 ? <Page1 /> : instructionPage === 1 ? <Page2 /> : instructionPage === 2 ? <Page3 /> : <Page4 />
                    }
                    <div className="flex justify-center gap-4 mt-4">
                        <button className="primary-button" onClick={handlePrev}>{"< Prev"}</button>
                        <div className="flex gap-2 items-center grow justify-center">
                            {Array.from({ length: maxPages }, (_, i) => i).map((i) => (
                                <div key={i} className={`w-4 h-4 rounded-full ${i === instructionPage ? "bg-slate-700" : "bg-gray-300"}`}></div>
                            ))}
                        </div>
                        {instructionPage !== 3 ? <button className="primary-button" onClick={handleNext}>{"Next >"}</button> : <button className="primary-button" onClick={handleCloseTOSModal}>Skip</button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export function Page1() {
    return (
        <div className="relative">
            <img src={AccountPage} alt="Logo" className="w-[80vh] mx-auto mt-4" />
            <div className="flex justify-center gap-4 mt-4">
                <p>Fill in your billing details in the <a href="https://alumni-tutoring.com/account" className="text-blue-600">Account page</a>.</p>
            </div>
        </div>
    );
}

export function Page2() {
    return (
        <div className="relative">
            <img src={TutorPage} alt="Logo" className="w-[80vh] mx-auto mt-4" />
            <div className="flex justify-center gap-4 mt-4">
                <p>Find the correct Tutor for you on the <a href="https://alumni-tutoring.com/tutors" className="text-blue-600">Tutor page</a>.</p>
            </div>
        </div>
    );
}

export function Page3() {
    return (
        <div className="relative">
            <img src={BookingPage} alt="Logo" className="w-[80vh] mx-auto mt-4" />
            <div className="flex justify-center gap-4 mt-4">
                Choose your available times and details about your booking.
            </div>
        </div>
    );
}

export function Page4() {
    return (
        <div className="relative">
            <img src={BookingRequestPage} alt="Logo" className="w-[80vh] mx-auto mt-4" />
            <div className="flex justify-center gap-4 mt-4">
                <p>View your bookings in the Request tab on the <a href="https://alumni-tutoring.com/user-calendar" className="text-blue-600">Calendar page</a>.</p>
            </div>
        </div>
    );
}